var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column"},[_c('sidebar')],1),_c('div',{staticClass:"column is-10"},[_c('navbar'),_c('notification')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }